import {observer} from 'mobx-react';
import React, {useEffect} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import './rates-page.scss';
import useStore from '../../store';
import {useParams} from 'react-router-dom';
import {SearchFieldComponent} from 'n2p-ui-library';
import classNames from 'classnames';
import { ReactComponent as FirstArrow } from '../../assets/images/first-arrow.svg';
import { ReactComponent as PreviousArrow } from '../../assets/images/previous-arrow.svg';
import { ReactComponent as NextArrow } from '../../assets/images/next-arrow.svg';
import { ReactComponent as LastArrow } from '../../assets/images/last-arrow.svg';
import { ReactComponent as InboundSvg } from '../../assets/images/inbound.svg';
import { ReactComponent as OutboundSvg } from '../../assets/images/outbound.svg';
import {ErrorCode} from "../../domains/errorCode";


export const RatesPage = observer(() => {
  const {shortName} = useParams<{ tenantId: string; shortName: string }>();
  const {t} = useTranslation('', {keyPrefix: 'RATES_PAGE'});
  const {rateStore} = useStore();
  const {isLoading, pagingRates, errorCode} = rateStore;

  useEffect(() => {
    if (shortName) {
      rateStore.init(shortName);
    }
  }, [shortName, rateStore]);

  const {page, pageSize, totalCount, totalPages} = pagingRates;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalCount);

  const isFirst = page === 1;
  const isLast = page === totalPages;
  const formatter = new Intl.NumberFormat(navigator.language, {
    style: 'decimal',
    maximumFractionDigits: 7,
  });

  return <div className="container-template rate-page">
    <div className="template-body">
      <div className="title d-flex">{t('TITLE')}</div>
      <div className="search-wrapper">
        <SearchFieldComponent
          clearButton
          onChange={value => rateStore.searchField = value}
          placeholder={t('PLACEHOLDER')}
          onEnter={() => {
            rateStore.searchRates(1)
          }}
        />

        <button type="button"
                className={classNames('n2pc-btn-primary', isLoading && 'n2pc-btn-primary_loading')}
                onClick={() => rateStore.searchRates(1)} disabled={isLoading}>
          {t('SEARCH')}
        </button>
      </div>

      {pagingRates.items.length === 0 && errorCode === ErrorCode.NoResultsFound && <div className={'no-results'}>
        <div>{t('NO_RESULTS_FOUND')}</div>
      </div>}

      {pagingRates.items.length > 0 && <div className={'rates-wrapper'}>
        <div className={'rate-row rates-header'}>
          <div>{t('DIAL_CODE')}</div>
          <div>{t('COUNTRY')}</div>
          <div>{t('RATE')}</div>
        </div>

        <div className={'rate-row-wrapper'}>
          {pagingRates.items.map((rate, index) =>
            <div className={'rate-row'} key={index}>
              <div>
                {rate.direction === 1 ? <InboundSvg /> : <OutboundSvg />}
                {rate.dialCode}
              </div>
              <div>{rate.locationName}</div>
              <div>{rate.perMinuteRate === -1 ? t('BLOCKED') : formatter.format(rate.perMinuteRate)}</div>
            </div>)}
        </div>

        {totalPages > 1 && <div className={'paging-wrapper'}>
          <div className={'paging-info'}>
            <strong>{from}</strong> {t('TO')} <strong>{to}</strong> {t('OF')} <strong>{totalCount}</strong>
          </div>
          <div className={'paging-buttons'}>
            <button onClick={() => rateStore.searchRates(1)} disabled={isFirst} title={t('FIRST')}>
              <FirstArrow />
            </button>
            <button onClick={() => rateStore.searchRates(page - 1)} disabled={isFirst} title={t('PREVIOUS')}>
              <PreviousArrow />
            </button>
            <span>{t('PAGE')} <strong>{page}</strong> {t('OF')} <strong>{totalPages}</strong></span>
            <button onClick={() => rateStore.searchRates(page + 1)} disabled={isLast} title={t('NEXT')}>
              <NextArrow />
            </button>
            <button onClick={() => rateStore.searchRates(totalPages)} disabled={isLast} title={t('LAST')}>
              <LastArrow />
            </button>
          </div>
        </div>}
      </div>}
    </div>


    <div className="template-inner">
      <Trans
        i18nKey={'RATES_PAGE.CALLS_ARE_BILLED'}
      />
    </div>
  </div>;
});
